import React from 'react';
import styles from "./ScreenshotViewerModal.module.css"
import clsx from 'clsx';
import ArrowButton from '../../../ArrowButton';

interface ScreenshotViewerModalProps {
    src?: string | null;
    isOpen?: boolean;
    onClose?: () => void;
    onSendClicked?: (value: string) => void;
}

const ScreenshotViewerModal: React.FC<ScreenshotViewerModalProps> = ({ src, isOpen = false, onClose, onSendClicked }) => {
    if (!isOpen) return null

    return (
        <div className={styles.modalOverlay} >
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <div style={{ flex: 1, flexDirection: "row", display: "flex", gap: "16px" }}>
                    </div>
                    <button className={styles.closeButton} onClick={onClose}>
                        ×
                    </button>
                </div>
                <div className={styles.modalBody}>
                    {src && <img src={src} />}
                </div>
                <div className={styles.modalFooter} >
                    <button className={clsx(styles.button, styles.warning)} onClick={onClose}>
                        Cancel
                    </button>
                    <ArrowButton onClick={() => { (src && onSendClicked) && onSendClicked(src); onClose && onClose() }} />
                </div>
            </div>
        </div>
    );
};

export default ScreenshotViewerModal;